import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { services } from '../mock';

const Services = () => {
  return (
    <div className="bg-gray-950 text-white">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Services</h1>
            <p className="text-xl text-gray-400 leading-relaxed">
              Comprehensive precision CNC machining solutions for aerospace, defense, and industrial applications. 
              From prototype to production, we deliver excellence at every stage.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service) =>
            <Card key={service.id} className="bg-gray-900 border-gray-800 overflow-hidden group hover:border-red-600 transition-all duration-300">
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-2/5 h-64 md:h-auto relative overflow-hidden">
                    <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    style={service.id === 'production-machining' ? { objectPosition: 'center -3px' } : {}} />

                  </div>
                  <div className="md:w-3/5 p-6">
                    <h3 className="!font-semibold !text-2xl mb-3 !text-[#E5E6E5]">{service.title}</h3>
                    <p className="text-gray-400 mb-4">{service.shortDesc}</p>
                    <div className="space-y-2 mb-6">
                      {service.capabilities.slice(0, 3).map((capability, index) =>
                    <div key={index} className="flex items-start space-x-2">
                          <span className="text-red-500 mt-1">•</span>
                          <p className="text-sm text-gray-400">{capability}</p>
                        </div>
                    )}
                    </div>
                    <Link to={`/services/${service.id}`}>
                      <Button variant="ghost" className="text-red-500 hover:text-red-400 p-0 h-auto font-semibold group">
                        Learn More
                        <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 border-t border-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl text-gray-300 mb-8">
            Contact us today to discuss your precision machining needs and receive a custom quote.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/contact">
              <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-md font-semibold transition-all duration-300">
                Request a Quote
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-gray-600 text-white hover:bg-gray-800 px-8 py-3 rounded-md font-semibold">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>);

};

export default Services;